(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-load-more"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('custom-collection-load-more')) {
    class CustomCollectionLoadMore extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.custom-collection-load-more__button');
        this.status = this.querySelector('.custom-collection-load-more__status');
        this.productContainer = document.getElementById('ProductGridContainer');
        this.grid = null;
        this.hasAppended = false;
        this.loading = false;
        this.allowNativeNavigation = false;
        this.refreshFrame = null;

        if (!this.button || !this.productContainer || !window.fetch || !window.DOMParser) return;

        this.onButtonClick = this.onButtonClick.bind(this);
        this.button.addEventListener('click', this.onButtonClick);

        this.observer = new MutationObserver(() => {
          if (this.loading || this.refreshFrame) return;

          this.refreshFrame = window.requestAnimationFrame(() => {
            this.refreshFrame = null;
            this.refresh();
          });
        });

        this.observer.observe(this.productContainer, {
          childList: true,
          subtree: true
        });

        this.refresh();
      }

      disconnectedCallback() {
        if (this.button && this.onButtonClick) {
          this.button.removeEventListener('click', this.onButtonClick);
        }

        if (this.observer) this.observer.disconnect();
        if (this.refreshFrame) window.cancelAnimationFrame(this.refreshFrame);
      }

      findNextLink(root) {
        return root.querySelector('.pagination-wrapper .pagination__item--prev[href]');
      }

      refresh() {
        const nextGrid = this.productContainer.querySelector('#product-grid');
        const pagination = this.productContainer.querySelector('.pagination-wrapper');

        if (nextGrid !== this.grid) {
          this.grid = nextGrid;
          this.hasAppended = false;
          this.allowNativeNavigation = false;
        }

        if (!this.grid) {
          this.disableEnhancement();
          return;
        }

        const currentPage = pagination
          ? Number.parseInt(pagination.dataset.page || '1', 10)
          : 1;
        const nextLink = this.findNextLink(this.productContainer);

        /*
          Una visita diretta a ?page=2 (per esempio da Google) conserva la
          paginazione completa. L'interfaccia progressiva parte dalla prima
          pagina, oppure prosegue dopo un caricamento gia' effettuato.
        */
        if (!this.hasAppended && currentPage > 1) {
          this.disableEnhancement();
          return;
        }

        if (!nextLink) {
          this.button.hidden = true;
          this.button.removeAttribute('aria-busy');

          if (!this.hasAppended) {
            this.productContainer.classList.remove('custom-load-more-enhanced');
          }

          return;
        }

        this.nextUrl = nextLink.href;
        this.button.href = this.nextUrl;
        this.button.hidden = false;
        this.button.textContent = this.dataset.idleLabel;
        this.productContainer.classList.add('custom-load-more-enhanced');
      }

      disableEnhancement() {
        this.button.hidden = true;
        this.button.removeAttribute('aria-busy');
        this.productContainer.classList.remove('custom-load-more-enhanced');
      }

      onButtonClick(event) {
        if (this.allowNativeNavigation || this.loading || !this.nextUrl) return;

        event.preventDefault();
        this.loadNextPage();
      }

      async loadNextPage() {
        this.loading = true;
        this.button.setAttribute('aria-busy', 'true');
        this.button.textContent = this.dataset.loadingLabel;
        this.status.textContent = this.dataset.loadingLabel;

        try {
          const publicUrl = new URL(this.nextUrl, window.location.origin);
          const requestUrl = new URL(publicUrl.href);
          const sectionId = this.grid.dataset.id;

          if (!sectionId) throw new Error('Missing collection section id');

          requestUrl.searchParams.set('section_id', sectionId);

          const response = await window.fetch(requestUrl.href, {
            credentials: 'same-origin',
            headers: {
              'X-Requested-With': 'XMLHttpRequest'
            }
          });

          if (!response.ok) {
            throw new Error(`Collection page request failed: ${response.status}`);
          }

          const html = await response.text();
          const parsedDocument = new DOMParser().parseFromString(html, 'text/html');
          const fetchedContainer = parsedDocument.getElementById('ProductGridContainer');
          const fetchedGrid = fetchedContainer && fetchedContainer.querySelector('#product-grid');

          if (!fetchedContainer || !fetchedGrid) {
            throw new Error('Collection grid not found in response');
          }

          const newItems = Array.from(fetchedGrid.children);
          if (!newItems.length) throw new Error('No products returned');

          const fragment = document.createDocumentFragment();
          newItems.forEach((item) => {
            item.classList.add('scroll-trigger--cancel');
            fragment.appendChild(item);
          });

          this.grid.appendChild(fragment);

          const currentPagination = this.productContainer.querySelector('.pagination-wrapper');
          const fetchedPagination = fetchedContainer.querySelector('.pagination-wrapper');

          if (currentPagination && fetchedPagination) {
            currentPagination.replaceWith(fetchedPagination);
          } else if (currentPagination) {
            currentPagination.remove();
          }

          this.hasAppended = true;
          this.allowNativeNavigation = false;

          window.history.replaceState(
            window.history.state,
            '',
            `${publicUrl.pathname}${publicUrl.search}${publicUrl.hash}`
          );

          this.status.textContent = `${newItems.length} ${this.dataset.loadedLabel}`;

          document.dispatchEvent(
            new CustomEvent('dh:collection:products-appended', {
              detail: {
                count: newItems.length,
                grid: this.grid,
                url: publicUrl.href
              }
            })
          );
        } catch (error) {
          console.warn('[Custom load more]', error);
          this.allowNativeNavigation = true;
          this.productContainer.classList.remove('custom-load-more-enhanced');
          this.status.textContent = this.dataset.errorLabel;
        } finally {
          this.loading = false;
          this.button.removeAttribute('aria-busy');
          this.button.textContent = this.dataset.idleLabel;
          this.refresh();
        }
      }
    }

    customElements.define('custom-collection-load-more', CustomCollectionLoadMore);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-customer-care"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCustomerCare = (root) => {
      if (!root || root.dataset.customCareReady === 'true') return;

      const subject = root.querySelector('select[name="contact[Subject]"]');
      const orderField = root.querySelector('[data-custom-care-order]');
      const productField = root.querySelector('[data-custom-care-product]');
      if (!subject || !orderField || !productField) return;

      const setFieldState = (field, mode) => {
        const input = field.querySelector('input');
        const visible = mode !== 'hidden';
        const required = mode === 'required';

        field.hidden = !visible;
        field.classList.toggle('is-hidden', !visible);
        field.classList.toggle('is-required', required);
        if (input) {
          input.disabled = !visible;
          input.required = required;
          input.setAttribute('aria-required', required ? 'true' : 'false');
        }
      };

      const updateFields = () => {
        const option = subject.selectedOptions[0];
        setFieldState(orderField, option?.dataset.orderMode || 'hidden');
        setFieldState(productField, option?.dataset.productMode || 'hidden');
      };

      subject.addEventListener('change', updateFields);
      updateFields();
      root.dataset.customCareReady = 'true';
    };

    const initializeAll = () => {
      document.querySelectorAll('.custom-customer-care').forEach(initializeCustomerCare);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAll, { once: true });
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeCustomerCare(event.target.querySelector('.custom-customer-care'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
